var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('img',{attrs:{"src":require("../assets/images/logo.png"),"width":"300"}}),_vm._v(" "),_c('h3',[_vm._v("Wuh!?")]),_vm._v(" "),_c('p',[_vm._v("Looks like you are lost.")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":_vm.notFound}},[_vm._v("Go Back To Login")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44cea942","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFound.vue
// module id = null
// module chunks = 